/* eslint-disable no-unused-vars */
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import {
  CompanyContainer,
  HeaderTitle,
  LoaderWrapper,
  StyledContainer,
  TableCell,
  TableWrapper,
} from '../../../services/settings/appStyle/global.style';

import { Table, IconButton as IconButtonWithText, Loader } from '../../../Components/uielements';
import { useUserContext } from '../../../hooks/UserContext';
import { managernotificationList } from '../../../services/bioplus-services/notifications';

import { DownloadIcon } from '../../../Components/icons';
import moment from 'moment';
import { IntlMessages } from '../../../helper/langHelper';
import { exportExcelFile } from '../../../helper/exportExcelHelper';

function extractData(dataArray) {
  if (dataArray) {
    const extractedData = dataArray?.map((item, index) => {
      return {
        Date: moment(item?.createdAt).format('DD-MM-YYYY'),
        companyName: item.companyName,
        premiseName: item.premiseName,
        geofenceName: item.geofenceName,
        createdAt: moment(item.createdAt).format('HH:mm:ss').toString(),
      };
    });
    return { bioplusUsers: extractedData };
  }
}

const ManagerNotification = () => {
  const userContext = useUserContext();
  const userRole = userContext?.company;
  const companyId = userRole?.companyId?.id;
  const premiseId = userRole?.premiseId;

  const { userPermission } = userContext;
  const isUserAllowToManage = userPermission?.find(
    (permission) => permission?.label === 'notification'
  );

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const usersQuery = useQuery(['notificationList', companyId, page, pageSize], () =>
    managernotificationList(companyId, premiseId, page, pageSize)
  );
  console.log(usersQuery, 'usersQuery');
  const userTableData = usersQuery?.data ?? [];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  //   table coulmns
  const userColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.date" />,
        accessor: 'createdAt',
        Cell: (cellData) => (
          <TableCell>
            {' '}
            {cellData.value ? moment(cellData.value).format('DD-MM-YYYY') : '--'}
          </TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.company.name" />,
        accessor: 'companyName',
      },
      {
        Header: <IntlMessages id="table.col.premise.name" />,
        accessor: 'premiseName',
      },
      {
        Header: <IntlMessages id="table.col.geofence.name" />,
        accessor: 'geofenceName',
        width: '20%',
      },
      {
        Header: <IntlMessages id="table.col.notification.time" />,
        accessor: 'created',
      },
    ],
    []
  );

  const excelFormatData = extractData(usersQuery?.data?.items);
  const fileName = `Notifications-${userRole?.companyName}-${moment().format(
    'DD-MM-YYYY-hh.mm A'
  )}.xlsx`;
  const columnConfig = [
    { header: 'Date', key: 'Date', width: 20 },
    { header: 'Entity Name', key: 'companyName', width: 30 },
    { header: 'premise Name', key: 'premiseName', width: 30 },
    { header: 'Geofence Name', key: 'geofenceName', width: 30 },
    { header: 'Created At', key: 'createdAt', width: 20 },
  ];

  if (usersQuery.isLoading) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }
  return (
    <StyledContainer>
      <CompanyContainer>
        <HeaderTitle>
          <IntlMessages id="nav.records.notifications" />
        </HeaderTitle>
        {isUserAllowToManage?.isReport && excelFormatData && (
          <IconButtonWithText
            text={<IntlMessages id="button.text.downloadExcel" />}
            icon={<DownloadIcon />}
            onClick={() => exportExcelFile(excelFormatData, fileName, columnConfig)}
          />
        )}
      </CompanyContainer>
      <TableWrapper>
        <Table
          data={userTableData}
          columns={userColumns}
          hasFooter={true}
          page={page}
          pageSize={pageSize}
          prevPage={handlePreviousPage}
          nextPage={handleNextPage}
          total={usersQuery?.data?.length || 0}
        />
      </TableWrapper>
    </StyledContainer>
  );
};

export default ManagerNotification;
